import { css } from '@emotion/css';

export const animated = css`
  width: 100%;
`;
